import React, { ReactNode } from "react";
import { useWordAnimation } from "./useWordAnimation";

export function WordFill({
  text,
  delay = 100,
  variant = "light",
  className = "",
}: {
  text: string | ReactNode;
  delay?: number;
  variant?: "dark" | "light";
  className?: string;
}) {
  const { ref, words, isVisible } = useWordAnimation(text);

  return (
    <span ref={ref} className={className }>
      {words.map((word, i) => (
        <span
          key={i}
          className={`word-anim-${variant} ${isVisible ? "animate" : ""}`}
          style={{ transitionDelay: `${i * delay}ms` }}
        >
          {word}
        </span>
      ))}
    </span>
  );
}
